import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { egretAnimations } from "../../../shared/animations/egret-animations";
import { TransactionService } from '../../../shared/services/MyServices/transaction.service';
import { HttpErrorResponse } from '@angular/common/http';
import { first } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { UserRegistration } from 'app/shared/models/user-registration';
import { ApproveData } from 'app/shared/models/models';
import { AppConfirmService } from '../../../shared/services/app-confirm/app-confirm.service';
import { AppLoaderService } from '../../../shared/services/app-loader/app-loader.service';
import { DataPassService } from '../../../shared/services/MyServices/data-pass.service';
import {Page} from '../../../../../src/app/shared/models/PaginationPage';

@Component({
  selector: 'app-bank-list',
  templateUrl: './bank-list.component.html',
  styleUrls: ['./bank-list.component.scss'],
  animations: egretAnimations
})
export class BankListComponent implements OnInit {
  page = new Page();
  BuyerListData: UserRegistration[];
  public items: any[];
  temp = [];
  public getItemSub: Subscription;
  constructor(private router: Router,
    private confirmService: AppConfirmService,
    private loader: AppLoaderService,
    private TransService: TransactionService,
    private DataPassServic: DataPassService
  ) {

    this.page.pageNumber = 0;
    this.page.size = 10;
    this.page.totalElements=0;
   }

  ngOnInit() {

    this.getBankList(0)

    //  this.loader.open();

  }

  getBankList(Offset) {
    
    const ObjData: BankList = {} as BankList;
    ObjData.offset = Offset;

   // let json = '{"distributor_code":"DISTCODE"}';
    this.getItemSub = this.TransService.GetBankList('')
      .subscribe(data => {
        // this.loader.close();
        if (data instanceof HttpErrorResponse) {
          return;
        }

        if (data.success = true) {
          this.page.totalElements=data.rangeInfo.page_count;
          this.items = this.temp = data.data;
        // console.log(this.items);
          //this.items =this.temp = data;
        }
        else {
          Swal.fire(data.data.msg, 'Error')
        }
      });


  }

  checkcolor(Color) {
   // console.log(Color);
    if (Color == "APPROVED") {
      return 'green';
    }
    else {
      return 'red';
    }
}


  openPopUp(data: any = {}, isNew?) {
    // console.log(data);
    this.DataPassServic.setBankDetailData(data);
    this.router.navigateByUrl('pages/BankDetail');
  }

  deleteItem(row) {

  }



  updateFilter(event) {
    const val = event.target.value.toLowerCase();
    var columns = Object.keys(this.temp[0]);
    // Removes last "$$index" from "column"
    columns.splice(columns.length - 1);
    // console.log(columns);
    if (!columns.length)
      return;

    const rows = this.temp.filter(function (d) {
      for (let i = 0; i <= columns.length; i++) {
        let column = columns[i];
        // console.log(d[column]);
        if (d[column] && d[column].toString().toLowerCase().indexOf(val) > -1) {
          return true;
        }
      }
    });

    this.items = rows;
  }

  setPage(pageInfo) {
  var offset= pageInfo.offset;
    this.getBankList(offset)
    }

}


export interface BankList {
  bank_details_id:number;
  offset: number;
  }